import { Base2Presenter } from "core/presenter";

class DiscountPresenter extends Base2Presenter {
  initialState() {
    return {
      filter: {
        description: "",
        type: "all",
        enabled: "true"
      }
    };
  }

  onCreate() {
    this.navigateTo("app.registration.discount.create");
  }

  handleFilterChange = filter => {
    this.enqueue({ filter });
  };
}

export default DiscountPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/list/presenter.js